<template>
<div class="p-4 md:p-6 login-tabs-container relative w-full" >
  <canvas ref="gameqr" class="ptawayqr"/>

  <!-- NOT HOST, WAITING FOR OTHERS-->


  <div v-if="(!amItheHost && !gameStarted) || (gameStarted && !amIVerified)">
    <h1 class="text-center my-4 font-semibold" v-if="amIVerified" >You're In!</h1>
    <p class="text-center my-6 font-medium text-lg text-dark" v-if="nameOfHost">You're joining {{ nameOfHost }}'s game of...</p>
    <img class="block mx-auto w-40 h-auto my-6 mb-8" src="@/assets/images/game/knowingme.png" />
  </div>

  <div v-show="!amItheHost &&!amIVerified">
    <p class="text-center">Type your name to join!</p>
    <vs-input size="large" label="Your name" v-validate="'required|max:20'" name="first_name" class="w-full my-6" v-model="imAJoinerName" placeholder="Enter your first name..." />
    <span class="font-medium block text-danger text-lg mb-4 text-center" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
    <vs-button color="primary" class="w-full" @click="verifyMe($event)">Join Game</vs-button>
  </div>

  <div v-if="amItheHost && !gameStarted" class="w-full">
    <h6 class="text-center text-dark font-medium mt-4 mb-10">Great! 🙌👍</h6>
    
    <div v-if="gameState.gameType === 'video'">
      <h2 class="text-center text-2xl mb-4 leading-normal text-primary font-extrabold">Now, get on a video call with friends, and share the game link to their phones!</h2>        
      <div class="w-full text-center">
        <img src="@/assets/images/phonetopcsmall.png" class="w-full lg:px-10"/>
        <p class="text-center font-normal text-dark my-2 mx-auto max-w-sm leading-normal">Our games work best if everyone <span class="font-bold">video</span> chat on the <span class="font-bold">computer</span> and <span class="font-bold">play</span> from their <span class="font-bold">phones</span> 😀</p>
      </div>
    </div>
    <div v-else>
      <h2 class="text-center text-2xl mb-4 leading-normal">Now, let players scan this QR code, or share the game link to their phones!</h2>
      <div class="w-full text-center">
        <img v-if="qrImgSrc" :src="qrImgSrc" class="w-full lg:px-10"/>
      </div>
    </div>

    <vs-input label="Game Link" disabled :value="gameLink" class="w-full mt-6 disabledclearvalue" />
    <vs-button color="secondary" icon-after type="border" @click="copyLink" class="w-full my-2" :icon-pack="copyIcon ? 'feather' : ''" :icon="copyIcon ? copyIcon : ''">{{ copyText }}</vs-button>
    <vs-button color="#4FCE5D" icon-after :href="whatsAppLink" class="w-full my-2 sm:hidden" icon-pack="feather" icon="icon-share-2">Share link on Whatsapp</vs-button>
    <vs-button class="w-full" @click="showQRPopup = true" type="border" color="secondary">Show QR Code <img v-if="qrImgSrc" :src="qrImgSrc" class="w-6 ml-1 float-right"/></vs-button>
    <vs-popup class="holamundo" title="Join Game QR Code" :active.sync="showQRPopup">
      <p class="my-0 text-center text-light font-normal max-w-xs mx-auto">(Share the below QR Code with other players so they can join the game)</p>
      <img v-if="qrImgSrc" :src="qrImgSrc" class="w-full lg:px-32 mx-auto block"/>
      <p class="mb-2 text-center text-primary font-bold text-xl">Scan with your phone to join!</p>
    </vs-popup>
    <!-- HOST, START GAME -->
    <vs-checkbox class="my-5 text-dark mb-2 mx-auto" v-model="isNotSocial">I'm playing with my work colleagues</vs-checkbox>
    <p class="text-light font-normal my-2" v-show="!isNotSocial">👍 Prompts will be more casual!</p>
    <vs-button v-if="amItheHost && !gameStarted" size="large" :disabled="!(playersVerifiedAtStart.length >= numPlayersNeeded && gameState.currentTurn === false)" class="w-full mt-2" color="primary" @click="startGame($event)">Start Game!</vs-button>
    <p v-if="!gameStarted" class="my-2 text-center">You can start the game when 2 or more players are in the game.</p>
  </div>


  <!-- HOST AND JOINER, SHOW WHOS JOINED -->
  <div class="my-2" v-if="!gameStarted">
    <label class="vs-input--label">YOUR CREW</label>
    <div class="block py-4" v-if="!gameState.currentTurn">
      <p class="text-dark font-medium text-l">
        <span class="block my-2" v-for="(player,i) in playersVerifiedAtStart">
            {{ (i === 0 ? '✔️' : '✔️') + (player.name === myName ? myName + ' (You)' : player.name) }}
            <vs-button v-if="amItheHost && player.uid !== myUID" :key="JSON.stringify(playerUIDToNames) + String (player.uid)" size="small" type="border" color="primary" class="inline-block ml-2" @click="removeFromPUTN($event,player.uid)" icon-pack="feather" icon="CopyIcon"> Remove</vs-button>
          </span>
      </p>
    </div>
    <p v-if="!gameStarted && !amItheHost && amIVerified" class="my-2 text-center">Waiting for everyone... {{ nameOfHost}} can start the game when all players have joined.</p>
    <p class="font-semibold text-primary text-center my-4">Players can still join or be removed after the game started!</p>
    <div class="text-dark">
      <vs-divider/>
      <ul class="font-medium">
        <li class="my-3" v-if="amItheHost">☝️ <span class="font-bold">Don't</span> accidentally <span class="font-bold">join the game link</span>! You'll play from this page.</li>
        <li class="my-3" v-if="!amItheHost">☝️ If you lose the game, <span class="font-bold">enter the way you came</span>.</li>
        <li class="my-3" v-if="amItheHost">☝️ If you lose the game, open the <span class="font-bold">game link</span> in this <span class="font-bold">same browser</span> you hosted from.</li>
        <li>☝️ If you get stuck, <span class="font-bold">refresh your browser.</span></li>
      </ul>
    </div>
  </div>


  <div v-if="gameStarted && amIVerified">

    <div v-if="screenMessageLocal && screenMessageLocal !== 'override'" class="text-center">

      <div v-if="screenMessageLocal.gameOver">

        <h2 class="mt-10">🏆 😁 🥳 🏆</h2>
        <h2 class="my-2 mb-4 font-bold text-4xl">{{ playerUIDToNames[screenMessageLocal.gameOver] }} wins!!</h2>
        <h2 class="mb-10">🏆 🥳 😁 🏆</h2>
        <p class="my-8 font-semibold text-dark text-center" v-if="!amItheHost && screenMessageLocal.gameOver">Want to play again? {{ playerUIDToNames[gameState.hostUID] }} can start a new round by selecting "Play Again".</p>

      </div>

      <p class="text-secondary mt-2" v-if="screenMessageLocal.wasHostSkip">{{ playerUIDToNames[gameState.hostUID] }} ended the round early.</p>
      <p class="mt-6">{{ screenMessageLocal.questionAsked }}</p>
      <vs-divider/>
      <div v-if="screenMessageLocal.answerType !== 'scale'" class="my-10">
        <h1 class="font-extrabold">{{ screenMessageLocal.correctAnswer }}!</h1>
      </div>
      <div v-else class="px-4">
        <p class="mt-10 mb-1 text-sm">Their answer</p>
        <vs-progress :height="30" :percent="screenMessageLocal.correctAnswer" color="secondary" class="mb-5 w-full"/>
      </div>
      <vs-divider/>
      <div class="text-left">
        <vs-button v-if="screenMessageLocal && !screenMessageLocal.gameOver" type="border" class="w-full my-4" @click="() => {screenMessageLocal = false}">Next question ></vs-button>
        <vs-button v-if="screenMessageLocal && screenMessageLocal.gameOver && amItheHost" size="large" class="w-full my-4" @click="playAgain">Play again ></vs-button>
      
      <div class="mt-3" v-for="input in screenMessageLocalInputs">

        <p class="float-left text-dark inline-block font-medium " style="max-width: 40%;">{{ playerUIDToNames[input.uid] }}<span v-if="input.correct">✅</span><span v-else>❌</span></p>
        <div class="mb-2">
          <p v-if="screenMessageLocal.answerType !== 'scale'" style="max-width: 60%;" class="text-dark inline-block float-right" :class="{'text-sm': screenMessageLocal.answerType === 'multi', 'text-lg mb-2 font-semibold': screenMessageLocal.answerType !== 'multi'}">"{{ input.input }}"</p>
          <p v-else class="inline-block relative float-right mb-2" style="bottom:0.1rem;">
            <span class="inline-block text-sm text-light relative" style="top: -0.4rem; margin-right: 0.3rem;">Answer:</span><vs-progress :height="20" :percent="input.input" color="dark" class="w-32"></vs-progress>
          </p>
        </div>
        <div class="relative">
          <span class="block text-sm text-center w-full absolute" style="margin-bottom: 0.4rem; z-index: 100; bottom: 0; left: 0;">Score: {{ input.newScore }}</span>
          <vs-progress :height="20" :percent="Math.round((input.newScore / gameState.winScore) * 100)" color="secondary"></vs-progress>
        </div>
        <vs-divider/>
      </div>
      <p class="text-center">First to {{ gameState.winScore }} points, wins!</p>
      </div>

    </div>
    

    <div v-if="(!screenMessageLocal && !gameOver) || screenMessageLocal === 'override'">
      <p class="leading-thrice text-center" v-if="gameState.turnNo === 0 && !iHaveVotedThisRound">Game Started!⚡️</p>
      <div v-if="screenMessageLocal === 'override'">
        <p v-if="!gameState.removedPlayer" class="leading-thrice text-center text-secondary" >{{ playerUIDToNames[gameState.hostUID] }} has skipped the turn.</p>
        <p v-else class="leading-thrice text-center text-secondary" >{{ gameState.removedPlayer }} has left the game. <span v-if="gameState.newHost">{{ playerUIDToNames[gameState.hostUID] }} is now the new host.</span></p>
        <vs-divider/>
      </div>
      <div class="" v-if="everyoneVote">
        <div v-if="someoneNeedsToRead && !isMyTurn && !iHaveVotedThisRound">
            <h2 class="text-center text-4xl mt-2">☝️</h2>
            <h2 class="text-center mb-2"><span class="font-bold">{{ someoneNeedsToRead.name }}</span> to read!</h2>
            <p class="text-center my-6 text-lg max-w-74 mx-auto">{{ someoneNeedsToRead.name }}, read the question on your screen <span class="font-bold">out loud!</span></p>
        </div>
        <div v-if="isMyTurn && someoneNeedsToRead && !iHaveVotedThisRound">
            <p class="text-center mt-3 text-dark"><span class="font-bold">Your turn</span> to <span class="font-bold">read out loud:</span></p>
            <p class="text-center text-dark my-4 text-2xl font-extrabold">{{ questionType === 'multi' ? whatsTheQuestion.question : whatsTheQuestion }}</p>
        </div>


        <div v-if="!iHaveVotedThisRound && showVoteButtonsLocal">
            <p class="text-center text-sm my-6 max-w-74 mx-auto" v-if="currentTurn.subject.uid !== myUID">What's your answer to {{ isMyTurn ? 'the' : someoneNeedsToRead.name + "'s" }} question?</p>
            <p class="text-center my-6 max-w-74 mx-auto font-bold" v-else>What is the correct answer?</p>
            <div v-if="questionType === 'scale'" class="text-center">
              <p class="text-sm text-light">High</p>
              <vue-slider
              v-model="myRangeInput"
              direction="btt"
              :height="230"
              :tooltip="'none'"
              style="display: inline-block;"
              railStyle="width: 16px; background-color: #E8E8E8;"
              :dotSize="40"
              dotStyle="background-color: rgba(255,255,255,0.8)!important; border: 3px solid black !important;"
              class=""
              ></vue-slider>
              <p class="text-sm -mt-1 text-light">Low</p>
              <p class="text-center my-4" v-if="currentTurn.subject.uid === myUID">Be honest about your answer! 😜</p>
              <vs-button class="w-full my-2" @click="vote($event, myRangeInput)" :key="'vbtninptr' + gameState.turnNo">
                Submit
              </vs-button>
            </div>

            <div v-if="questionType === 'multi'">
              <vs-button v-for="(o,i) in whatsTheQuestion.options" type="border" class="w-full my-2" @click="vote($event, i)" :key="'vbtn' + i + gameState.turnNo">
                {{ o }}
              </vs-button>
              <p class="text-center my-4" v-if="currentTurn.subject.uid === myUID">Be honest about your answer! 😜</p>
            </div>

            <div v-if="questionType === 'input'">
              <vs-input placeholder="What's your answer?" v-validate="'required|max:30'" v-model="myInput" class="w-full" name="answer" :key="'inputtxt' + gameState.turnNo"/>
              <span class="font-medium block text-danger text-lg mb-4 text-center" v-show="errors.has('answer')">{{ errors.first('answer') }}</span>
              <p class="text-center my-4" v-if="currentTurn.subject.uid === myUID">Be honest about your answer! 😜</p>
              <vs-button class="w-full my-2" @click="vote($event, myInput.trim())" :disabled="errors.has('answer') || myInput === ''" :key="'vbtninpt' + gameState.turnNo">
                Submit
              </vs-button>
            </div>
        </div>

        <div v-if="playersVotedThisRound && iHaveVotedThisRound" class="mt-4 text-center text-dark">
            <h5 class="my-10 font-medium">{{ questionType === 'multi' ? whatsTheQuestion.question : whatsTheQuestion }}</h5>
            <vs-divider/>
            <h3 class="my-10">You've answered 👌</h3>
            <vs-divider/>
            <p class=" my-8 font-semibold">Still to answer</p>
            <div class="text-center my-4 mb-8">
                <span class="block my-1" v-for="uid in playersVotedThisRound">{{playerUIDToNames[uid]}}</span>
            </div>
        </div>

       
       <div v-if="amItheHost" class="mt-5 text-center font-semibold">
        
        <vs-divider/>
        <p class="text-center mb-4 text-sm text-light">Host actions</p>
        
        <vs-button class="w-full font-normal" type="flat" v-if="!iWantToEndRound" @click.prevent="() => {
        iWantToEndRound = true
        iWantToLeave = false
        iWantToRemovePlayer = false
        iWantToRemovePlayerI = 0
        removeMsg = false
        }">End turn early ></vs-button>
          <p v-else>Are you sure you want to end this turn? Not everyone has given answers!
            <vs-button type="border" class="font-medium w-full my-2" href="" @click.prevent="vote($event,'override')">End turn</vs-button>
          </p>
          
        <vs-button v-if="!iWantToRemovePlayer" class="font-normal text-center w-full" type="flat" icon-pack="feather" icon="icon-x-circle" @click="() => {
          iWantToRemovePlayer = true
          iWantToLeave = false
          leaveMsg = false
          iWantToEndRound = false
          }">Remove a Player</vs-button>
        <div class="" v-else>
          <p class="text-center text-dark">Who do you want to remove from the game?</p>
          <div class="w-full my-2" v-for="(player, i) in currentPlayersInSequence" v-if="player.uid !== myUID">
            <vs-radio  v-model="iWantToRemovePlayerI" :vs-value="i">{{ player.name }}</vs-radio>
          </div>
          <div class="overflow-auto">
            <vs-button class="font-normal float-left w-1/2" type="border" @click="() => {
              iWantToRemovePlayer = false
              iWantToRemovePlayerI = 0
              iWantToEndRound = false
              removeMsg = false
              }">Cancel</vs-button>
            <vs-button class="font-normal float-left w-1/2" @click="confirmRemovePlayer($event, {uid: currentPlayersInSequence[iWantToRemovePlayerI].uid})">Remove</vs-button>
          </div>
          <p v-if="removeMsg" class="py-4 w-full text-center text-dark">{{removeMsg}}</p>
        </div>

        </div>      

        <vs-button v-if="!iWantToLeave" class="font-normal text-center w-full" type="flat" icon-pack="feather" icon="icon-x-circle" @click="() => {
          iWantToLeave = true
          iWantToRemovePlayer = false
          iWantToEndRound = false
          iWantToRemovePlayerI = 0
          removeMsg = false
          }">Leave Game</vs-button>
          <div v-else>
            <p class="text-center text-dark">Are you sure you want to leave the game?</p>
            <div class="overflow-auto">
            <vs-button class="font-normal float-left w-1/2" type="border" @click="() => {
              iWantToLeave = false
              iWantToRemovePlayer = false
              iWantToEndRound = false
              iWantToRemovePlayerI = 0
              removeMsg = false
              }">Cancel</vs-button>
            <vs-button class="font-normal float-left w-1/2" @click="confirmRemovePlayer($event, {uid: myUID}, true)">Leave</vs-button>
            <p v-if="leaveMsg" class="py-4 w-full text-center text-dark">{{ leaveMsg }}</p>
          </div>
          </div>


        <div class="mt-6 p-6 lightycont">
          <label class="vs-input--label">Score</label>
          <div class="mt-3" v-for="player in currentScores">
            <p class="float-right inline-block">{{ player.score }} Point{{ player.score === 1 ? '':'s'}}</p>
            <h4 class="mb-2">{{ player.name }}</h4>
            <vs-progress :height="20" :percent="Math.round((player.score / gameState.winScore) * 100)" color="secondary"></vs-progress>
            <vs-divider/>
          </div>
          <p class="mt-1 text-sm text-center">First player to get {{ gameState.winScore }} points, wins!</p>
        </div>

        <vs-collapse type="margin" :open-hover="true" class="small block w-full mt-4">
          <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
            <div slot="header">
              How to play
            </div>
            <span class="text-dark">
              <p class="mb-4">The game is simple! Each player gets a turn to answer a question about themself.</p>
              <p class="my-4">Everyone else needs to answer the same question!</p>
              <p class="my-4">Players get points for answering the same as the player in question.</p>
              <p class="my-4 text-center">First player to get to {{ gameState.winScore }} points, wins!</p>
            </span>
          </vs-collapse-item>
        </vs-collapse>
      </div>


    </div>


  </div>
</div>
</template>


<script>
//
//<br>💡{{ guessesAllowed - player.guesses.length }}</span>
//
//

import qrCode from 'qrcode'

import {
  mapGetters
} from 'vuex'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import nosleep from 'nosleep.js'

import {
  Validator
} from 'vee-validate'

const dict = {
  custom: {
    first_name: {
      required: 'Your first name is required to play!',
      max: 'Your first name can\'t be longer than 20 characters.'
    }
  }
}

Validator.localize('en', dict)


function fallbackCopyTextToClipboard (text) {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    const msg = successful ? 'successful' : 'unsuccessful'
  } catch (err) {}

  document.body.removeChild(textArea)
}

function copyTextToClipboard (text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(function () {}, function (err) {})
}

export default {
  mounted () {
    if (this.gameLink) {
      this.generateQR()
    }    
  },
  data () {
    return {
      myNumber: '',
      myRangeInput: 50,
      myInput: '',
      isNotSocial: true, //used when host starts the game
      screenMessageLocal: false,
      copyText: 'Copy Link',
      btnsKey: 0,
      copyIcon: 'icon-copy',
      showQRPopup: false,
      imAJoinerName: '',
      iWantToEndRound: false,
      removeMsg: false,
      leaveMsg: false,
      iWantToRemovePlayer: false,
      iWantToRemovePlayerI: 0,
      iWantToLeave: false,
      numPlayersNeeded: 2,
      showPlayButton: false,
      qrImgSrc: false,
      showPlayAgain: true,
      showVoteButtonsLocal: true,
      lastShowFollow: false
    }
  },
  watch: {     
    gameStarted (v) {
      if (v) {
        this.scrollToTop()
      }
    },
    gameOver (v) {
      if (v) {
        this.screenMessageLocal = false
        this.showPlayAgain = true
      }
    },
    turnNo () {
      this.iWantToEndRound = false
      this.myInput = ''
      this.myRangeInput = 50
      this.iWantToRemoveSomeone = false
    },
    currentTurn (v) {
      /*
        if (typeof v.actionRequired !== "undefined") {
            if(v.actionRequired === 'allvote') {
                this.showVoteButtonsLocal = false
              //console.log('set timeout')

                setTimeout(() => {
                    this.showVoteButtonsLocal = true
                }, 5000)
            }
        } else {
            this.showVoteButtonsLocal = false
        }*/
    },
    screenMessage (v) {
    //console.log('sm changed:')
    //console.log(v)
      if ((v !== false || this.gameState.turnNo === 0)) {
        this.screenMessageLocal = v
      }
    }
  },
  computed: {
    screenMessageLocalInputs () {

      /*
        [ 
        { "correct": false, "input": 0, "newScore": 0, "uid": "edAtGv2bqsPsH7EpxS9pbAL0sN53" },
        { "correct": false, "input": 100, "newScore": 0, "uid": "VEdiiK94aKdbliQ0G7qeHGp1KeP2" } 
        ]
      */

      let inputs = []
      if (this.screenMessageLocal !== false) {        
        if (typeof this.screenMessageLocal.inputs !== 'undefined') {
          const theThis = this
          inputs = [...this.screenMessageLocal.inputs]
          inputs = inputs.sort(function (x, y) { return x.uid == theThis.myUID ? -1 : y.uid == theThis.myUID ? 1 : 0 })
        }
      }
      return inputs
    },
    whatsAppLink () {
      if (this.gameID && this.gameLink) {
        return `whatsapp://send?text= Join my game of "Knowing Me, Knowing You" on Remote Social!: ${  this.gameLink}`
      }
      return false
    },
    ...mapGetters({
      currentTurn: 'knowMe/currentTurn',
      drawTurn: 'knowMe/drawTurn',
      iAmTheJudge: 'knowMe/iAmTheJudge',
      someoneNeedsToRead: 'knowMe/someoneNeedsToRead',
      whatsTheQuestion: 'knowMe/whatsTheQuestion',
      isDrinkingGame: 'knowMe/isDrinkingGame',
      screenMessage: 'knowMe/screenMessage',
      currentPlayersInSequence: 'knowMe/currentPlayersInSequence',
      gameFinished: 'knowMe/gameFinished',
      gameLink: 'knowMe/gameLink',
      iHaveVotedThisRound: 'knowMe/iHaveVotedThisRound',
      amIVerified: 'knowMe/amIVerified',
      gameStarted: 'knowMe/gameStarted',
      gameOver: 'knowMe/gameOver',
      myName: 'knowMe/myName',
      nameOfHost: 'knowMe/nameOfHost',
      turnNo: 'knowMe/turnNo',
      questionType: 'knowMe/questionType',
      whosTheSubject: 'knowMe/whosTheSubject',
      isMyTurn: 'knowMe/isMyTurn',
      myUID: 'knowMe/myUID',
      playersVerifiedAtStart: 'knowMe/playersVerifiedAtStart',
      gameID: 'knowMe/gameID',
      currentScores: 'knowMe/currentScores',
      gameState: 'knowMe/currentGameState',
      amItheHost: 'knowMe/amItheHost',
      someOneNeedsToVote: 'knowMe/someOneNeedsToVote',
      everyoneVote: 'knowMe/everyoneVote',
      playersVotedThisRound: 'knowMe/playersVotedThisRound',
      playerUIDToNames: 'knowMe/playerUIDToNames',
      noMoreLeft: 'knowMe/noMoreLeft'
    })
  },
  components: {
    VueSlider
  },
  methods: {   
    removeFromPUTN ($event, uid) {
      
      this.makeBtnLoading($event, 'Removing...')

      this.$store.dispatch('removePlayerFromGame', {
        gameType: 'knowing',
        gameID: this.gameID,
        removeUID: uid
      }).then((result) => {
       
      }).catch((e) => {
        //console.log(e)
      })

    },
    generateQR () {
      const this2 = this
      //console.log(this.$refs.gameqr)
      //console.log(this.gameLink)
      qrCode.toCanvas(this.$refs.gameqr, this.gameLink, function (error) {
        if (error) console.error(error)
        //console.log('success!');
        //console.log(this2.$refs.gameqr.toDataURL())
        this2.qrImgSrc = this2.$refs.gameqr.toDataURL()
      })
    },
    confirmRemovePlayer ($event, { uid }, iLeave) {
    
      let notAllowedMsg = false
      if (this.currentPlayersInSequence.length === 2) {
        notAllowedMsg = 'You can\'t remove someone from this game - there\'s only 2 players left!'    
      }

      if (typeof iLeave !== 'undefined') {        
        if (notAllowedMsg) {
          this.leaveMsg = 'You can\'t leave this game - there\'s only 2 players left!'
          return
        }
        this.makeBtnLoading($event, 'Leaving...')        
      } else {
        if (notAllowedMsg) {
          this.removeMsg = notAllowedMsg
          return
        } 
        this.makeBtnLoading($event, 'Removing...')       
        iLeave = false 
      }    

      this.$store.dispatch('knowMe/removePlayer', {
        givenUID: uid
      }).then((result) => {

        if (iLeave) window.location.href = 'https://remotesocial.io' 

        this.scrollToTop()
        this.iWantToLeave = false
        this.iWantToRemovePlayer = false
        this.iWantToRemovePlayerI = 0
        this.leaveMsg = false
        this.removeMsg = false
      }).catch((e) => {
      //console.log(e)
      })
      
    },
    playAgain ($event) {
      this.$store.dispatch('knowMe/startGame', {
        resetGame: true
      }).then((result) => {
      }).catch((e) => {
      //console.log(e)
      })
    },
    getOrdinal (n) {
      let s = ['th', 'st', 'nd', 'rd'],
        v = n % 100
      return n + (s[(v - 20) % 10] || s[v] || s[0])
    },
    makeBtnLoading ($event, text) {

      const btnText = typeof text !== 'undefined' ? text : 'Connecting to players...'

      //console.log($event)
      const srcEl = $event.srcElement
      srcEl.innerHTML = btnText
      srcEl.setAttribute('disabled', 'true')
    },
    copyLink () {
      this.copyText = 'Copied!'
      this.copyIcon = false
      copyTextToClipboard(this.gameLink)
    },
    vote ($event, input) {

      this.makeBtnLoading($event, 'Submitting...')

      let hostOverride = false
      if (input === 'override') {
        hostOverride = true
      }

      this.$store.dispatch('knowMe/vote', {
        input,
        hostOverride
      }).then((res) => {
        this.scrollToTop()
        //console.log(res)
      }).catch((e) => {
        //console.log(e)
      })
    },
    
    startGame ($event) {
      const noSleep = new nosleep()
      noSleep.enable()
      this.makeBtnLoading($event)

      
      this.$store.dispatch('knowMe/startGame', {
        resetGame: false,
        isSocial: !this.isNotSocial
      }).then((result) => {
      //console.log(result)
      }).catch((e) => {
      //console.log(e)
      })
    },

    verifyMe ($event) {
      this.$validator.validateAll().then(result => {
        if (result) {

          //check all RS parameters are present
          let allParamsOk = true
          if (typeof this.$route.query.uid === 'undefined' || typeof this.$route.query.accountId === 'undefined') allParamsOk = false
          if (!allParamsOk) {
            this.$vs.notify({
              title: 'Oops!',
              text: 'Something went wrong with joining this game. Taking you back to Remote Social...',
              time: 60000
            })
            setTimeout(() => {
              window.location.href = 'https://hub.remotesocial.io'
            }, 5000)
            return
          }
          //checks done

          const noSleep = new nosleep()
          noSleep.enable()

          this.$vs.loading()

          //call the FB function to add me to the game here
          this.$store.dispatch('knowMe/verifyMyName', {
            nameProvided: this.imAJoinerName,
            gameID: this.gameID,
            rsUID: decodeURIComponent(this.$route.query.uid),
            rsAccountID: decodeURIComponent(this.$route.query.accountId)
          }).then((result) => {

            this.$vs.loading.close()
            this.scrollToTop()
            this.screenMessageLocal = false
            //console.log(result)

            if (result.data.verified) {
              /*console.log('verified, sying that Im online')
              this.$store.dispatch('knowMe/startIAmOnline', {
                gameID: this.gameID
              })
              this.$store.dispatch('knowMe/startCheckingWhosOnline')*/
            } else {
            //console.log('I wasnt invited?')
              this.$vs.loading.close()
            }
            //do something
          }).catch((e) => {
          //console.log(e)
            this.scrollToTop()
          })

        }
      })
    }
  },

  created () {
    
    if (typeof this.$route.query.displayName !== 'undefined') {
      this.imAJoinerName = decodeURIComponent(this.$route.query.displayName)
    }

    this.screenMessageLocal = false
    const thisRoute = this.$route
    //check if game was just created by me, else it's a fresh load
    if (this.$store.state.knowMe.gameID) {
    //console.log('host created, connection already made')
      /*this.$store.dispatch('knowMe/startIAmOnline', {
        gameID: this.gameID
      })
      this.$store.dispatch('knowMe/startCheckingWhosOnline')*/
      //this.$store.commit('SET_GAME_ID',this.$store.state.knowMe.gameID)
      this.$vs.loading.close()
    } else {
      this.$vs.loading()
      //this is someone joining, or someone refreshing

        
      //sync state
        
      this.$store.dispatch('auth/registerUserAnonymous').then(() => {

        //look for game
        const gameID = thisRoute.query.gameId ? thisRoute.query.gameId : false

        if (!gameID) {
          window.location.href = 'https://hub.remotesocial.io'
        } else {
          //this.$store.commit('SET_GAME_ID',gameID)
          this.$store.dispatch('knowMe/syncState', {
            docID: gameID
          }).then(() => {
          //console.log('game ready to go, now need to verify')
            this.$vs.loading.close()
          }).catch((e) => {
            //bad game ID, reroute to 'this game doesn't exist page'
            window.location.reload()
          //console.log(e)
          })
        }          
      }).catch((e) => {
        //console.log(e)
      })
        
    }
  }
}
</script>

<style lang="scss">

.lightycont{
  background: #F1F8FF;
  border-radius: 7px;
}

.vue-slider {
  transform: translateX(-15%);
}

.login-tabs-container {
    min-height: 505px;

    .con-tab {
        padding-bottom: 14px;
    }

    .con-slot-tabs {
        margin-top: 1rem;
    }
}
</style>
